<script>
import Notification from "../reUse/Notification.vue";
import SignaturePad from "../reUse/SignaturePad.vue";
import TwoFactor from "./TwoFactorAuth.vue";
import UrejanjePodatkov from "./UrejanjePodatkov.vue";
import BrisanjeRacuna from "./BrisanjeRacuna.vue";
import Language from "./Jezik.vue";
import { i18n } from '@/i18n'
import sl from '@/Prevodi/UserSettings-sl.json';
import en from '@/Prevodi/UserSettings-en.json';
import it from '@/Prevodi/UserSettings-it.json';
export default {
  components: {
    Notification,
    SignaturePad,
    TwoFactor,
    Language,
    UrejanjePodatkov,
    BrisanjeRacuna
  },
  props: {
    pokaziModal: Boolean,
    UserID: String,
    User: String,
    FullUser: Object,
  },
  emits: ['zapri', 'odjava', 'dodajPodpis', 'izpisUporabnika'],
  data() {
    return {
      prevodi: false,
      oldPass: '',
      password: '',
      confirmedPass: '',
      passShower: false,
      nPassShower: false,
      ShowNoti: false,
      showPWreset: false,
      showPodatki: false,
      showBrisanjeR: false,
      showPodpis: false,
      showTwoF: false,
      showLanguage: false,
      text: '',
      types: '',
      stripeURL: '',
    }
  },
  watch: {
    pokaziModal() {
      if (this.pokaziModal) {
        this.ResetPass();
      } else {
        this.DetailsOff();
      }
    },
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  methods: {
    handleSave(dataUrl) {
      // console.log("Podpis prejet:", dataUrl)
      // tu ga lahko pošlješ na backend
      this.ShowNoti = true;
      this.text = this.$t('obvestila.podpisDodan');
      this.types = 'Uspešno';
    },
    PonastaviGeslo() {
      if (this.nPassShower) {
        this.confirmedPass = this.password;
      }
      //preverjanje, če se gesli ujemata
      if (this.confirmedPass !== this.password) {
        // alert('Gesli se ne ujemata');
        this.text = this.$t('obvestila.gesloNiUjema');
        this.types = "Napaka";
        this.ShowNoti = true;
      } else {
        var podatki = new URLSearchParams();
        podatki.append('sGeslo', this.oldPass);
        podatki.append('nGeslo', this.password);
        axios.post('./api/prijava/reset/', podatki, {withCredentials: true}).then((response) => {
          this.DetailsOff();
          // alert('Geslo uspešno spremenjeno. Samodejno boste odjavljeni čez nekaj sekund...');
          this.text = this.$t('obvestila.gesloSpremenjeno');
          this.types = "Uspešno";
          this.ShowNoti = true;
          setTimeout(() => {
            this.$router.push('/Logout');
          }, 100);
        }).catch((napaka) => {
          if (napaka.response.status === 402) {
            // alert('Vneseno staro geslo je napačno!');
            this.text = this.$t('obvestila.napacnoGeslo');
            this.types = "Napaka";
            this.ShowNoti = true;
          }
          if (napaka.response.status === 401) {
            this.$router.push('/Logout');
          }
          if (napaka.response.data.napaka !== undefined) {
            this.text = this.$t('obvestila.napakaPosodabljanja');
          } else {
            this.text = this.$t('obvestila.napakaPosodabljanja');
          }
          this.types = 'Napaka';
          this.ShowNoti = true;
        });
      }
    },
    DetailsOff() {
      $(this.$refs.modalPassReset).modal('hide');
      this.$emit('zapri');
    },
    ResetPass() {
      $(this.$refs.modalPassReset).modal('show');
    },
    OpenPWreset() {
      this.showPWreset = !this.showPWreset;
    },
    OpenUrejanjeP() {
      this.showPodatki = !this.showPodatki;
    },
    OpenBrisanjeRacuna() {
      this.showBrisanjeR = !this.showBrisanjeR;
    },
    OpenPodpis() {
      this.showPodpis = !this.showPodpis;
    },
    OpenTwoF() {
      this.showTwoF = !this.showTwoF;
    },
    OpenLanguage() {
      this.showLanguage = !this.showLanguage;
    },
    OpenSubscription() {
      var podatki = new URLSearchParams();
      podatki.append('stranka_id', this.FullUser.stranka_id);
      axios.post('./api/narocnina/uredi/', podatki, {withCredentials: true}).then((response) => {
        this.text = "Preusmerjeni boste na stran za urejanje naročnine";
        this.types = "Vprašanje";
        this.ShowNoti = true;
        this.stripeURL = response.data.stripeURL;
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = this.$t('obvestila.napakaBranja');
        } else {
          this.text = this.$t('obvestila.napakaBranja');
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    OpenStripeURL() {
      window.location.href = this.stripeURL;
    },
    IzpisiSe() {
      this.DetailsOff();
      this.$router.push('/Logout');
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
    handleSignature(data) {
      this.$emit('dodajPodpis', data);
    },
    PomocUporabnikom() {
      window.open('mailto:podpora@wingsi.app');
    }
  }
}
</script>
<template>
  <div class="modal modal-kartica modern-passreset-modal" ref="modalPassReset" tabindex="-1" role="dialog">

    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content modern-modal-content">
        <div class='modern-close-section'>
          <button class="modern-close-btn" @click.prevent="DetailsOff">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class='modern-modal-header'>
          <h5 class="modern-modal-title">
            <i class="fas fa-user-cog"></i>
            {{$t('main.title')}}
          </h5>
        </div>
        <div class="modern-modal-body col-12">
          <!-- JEZIK UPORABNIKA -->
          <div class="modern-section">
            <div class="modern-section-header" @click.prevent="OpenLanguage()" data-umami-event="Uporabnik-Nastavitve-Jezik">
              <div class="modern-section-icon">
                <i class="fas fa-language"></i>
              </div>
              <div class="modern-section-content">
                <h6 class="modern-section-title">{{$t('language.title')}}</h6>
                <p class="modern-section-desc">{{$t('language.description')}}</p>
              </div>
              <div class="modern-section-toggle">
                <i v-show="!showLanguage" class="fas fa-chevron-right"></i>
                <i v-show="showLanguage" class="fas fa-chevron-down"></i>
              </div>
            </div>
            <Language :FullUser :UserID v-if="showLanguage"/>
          </div>
          <div class="modern-section">
            <!--TUKAJ IMAVA GUMB KJER BOVA ODPIRALA RAZLIČNE (user settingse)-->
            <div class="modern-section-header" @click.prevent="OpenPWreset()" data-umami-event="Uporabnik-Nastavitve-MenjavaGesla">
              <div class="modern-section-icon">
                <i class="fas fa-unlock-alt"></i>
              </div>
              <div class="modern-section-content">
                <h6 class="modern-section-title">{{$t('geslo.title')}}</h6>
                <p class="modern-section-desc">{{$t('geslo.description')}}</p>
              </div>
              <div class="modern-section-toggle">
                <i v-show="!showPWreset" class="fas fa-chevron-right"></i>
                <i v-show="showPWreset" class="fas fa-chevron-down"></i>
              </div>
            </div>
            <transition-group name="fade">
              <div v-if="showPWreset" class="modern-section-body">
                <div class="modern-form-group">
                  <label :class="{ 'modern-label-hidden': oldPass.length > 0 }" class="modern-form-label" for="password">{{$t('geslo.labels.staroGeslo')}}</label>
                  <div class="modern-input-group">
                    <input class="modern-form-input" autocomplete="off" type="password" id="password" v-if="!passShower" v-model="oldPass" required />
                    <input class="modern-form-input" autocomplete="off" type="text" id="password" v-else v-model="oldPass" required />
                    <button type="button" class="modern-input-toggle" @click.prevent='passShower = !passShower'>
                      <i class='fas' :class="{'fa-eye-slash': !passShower, 'fa-eye': passShower}"></i>
                    </button>
                  </div>
                </div>
                <div class="modern-form-group">
                  <label :class="{ 'modern-label-hidden': password.length > 0 }" class="modern-form-label" for="secpassword">{{$t('geslo.labels.novoGeslo')}}</label>
                  <div class="modern-input-group">
                    <input class="modern-form-input" autocomplete="off" type="password" id="secpassword" v-if="!nPassShower" v-model="password" required />
                    <input class="modern-form-input" autocomplete="off" type="text" id="secpassword" v-else v-model="password" required />
                    <button type="button" class="modern-input-toggle" @click.prevent='nPassShower = !nPassShower'>
                      <i class='fas' :class="{'fa-eye-slash': !nPassShower, 'fa-eye': nPassShower}"></i>
                    </button>
                  </div>
                </div>
                <div class="modern-form-group" v-if="!nPassShower">
                  <label :class="{ 'modern-label-hidden': confirmedPass.length > 0 }" class="modern-form-label" for="secpasspassword">{{$t('geslo.labels.potrditevGesla')}}</label>
                  <input class="modern-form-input" autocomplete="off" type="password" id="secpasspassword" v-model="confirmedPass" required />
                </div>
                <div class="modern-form-actions">
                  <button class="modern-btn modern-btn-primary" @click.prevent="PonastaviGeslo()">
                    <i class="fas fa-key"></i>
                    {{$t('geslo.buttons.ponastaviGeslo')}}
                  </button>
                </div>
              </div>
            </transition-group>
          </div>
          <!-- Urejanje podatkov UrejanjePodatkov.js je child -->
          <div class="modern-section">
            <div class="modern-section-header" @click.prevent="OpenUrejanjeP()" data-umami-event="Uporabnik-Nastavitve-UrejanjePodatkov">
              <div class="modern-section-icon">
                <i class="fas fa-user-cog"></i>
              </div>
              <div class="modern-section-content">
                <h6 class="modern-section-title">{{$t('podatki.title')}}</h6>
                <p class="modern-section-desc">{{$t('podatki.description')}}</p>
              </div>
              <div class="modern-section-toggle">
                <i v-show="!showPodatki" class="fas fa-chevron-right"></i>
                <i v-show="showPodatki" class="fas fa-chevron-down"></i>
              </div>
            </div>
            <UrejanjePodatkov :FullUser :UserID v-if="showPodatki"/>
          </div>

          <!--TUKAJ JE SIGNATURE MODAL, ZA DODAJANJE PODPISA UPORABNIKA... PassReset.js je Parent komponenta, SignaturePad je child-->
          <div class="modern-section">
            <div class="modern-section-header" @click.prevent="OpenPodpis()" data-umami-event="Uporabnik-Nastavitve-Podpis">
              <div class="modern-section-icon">
                <i class="fas fa-signature"></i>
              </div>
              <div class="modern-section-content">
                <h6 class="modern-section-title"> {{$t('podpis.title')}}</h6>
                <p class="modern-section-desc">{{$t('podpis.description')}}</p>
              </div>
              <div class="modern-section-toggle">
                <i v-show="!showPodpis" class="fas fa-chevron-right"></i>
                <i v-show="showPodpis" class="fas fa-chevron-down"></i>
              </div>
            </div>
            <SignaturePad @saved="handleSave" @dodajPodpis="handleSignature" :FullUser :UserID v-if="showPodpis"/>
          </div>
          <!-- 2FA sekcija TwoFactorAuth.js je child -->
          <div class="modern-section">
            <div class="modern-section-header">
              <div class="modern-section-icon">
                <i class="fas fa-mobile"></i>
              </div>
              <div class="modern-section-content" @click.prevent="OpenTwoF()" data-umami-event="Uporabnik-Nastavitve-2FA">
                <h6 class="modern-section-title">{{$t('auth.title')}}</h6>
                <p class="modern-section-desc">{{$t('auth.description')}}</p>
              </div>
              <div class="modern-section-toggle">
                <i v-show="!showTwoF" class="fas fa-chevron-right"></i>
                <i v-show="showTwoF" class="fas fa-chevron-down"></i>
              </div>
            </div>
            <TwoFactor :FullUser :UserID v-if="showTwoF"/>
          </div>
          <!-- Brisanje uporabniškega profila -->
          <div class="modern-section">
            <div class="modern-section-header" @click.prevent="OpenBrisanjeRacuna()" data-umami-event="Uporabnik-Nastavitve-IzbrisRacuna">
              <div class="modern-section-icon">
                <i class="fas fa-user-times"></i>
              </div>
              <div class="modern-section-content">
                <h6 class="modern-section-title">{{$t('bracun.title')}}</h6>
                <p class="modern-section-desc">{{$t('bracun.description')}}</p>
              </div>
              <div class="modern-section-toggle">
                <i v-show="!showBrisanjeR" class="fas fa-chevron-right"></i>
                <i v-show="showBrisanjeR" class="fas fa-chevron-down"></i>
              </div>
            </div>
            <BrisanjeRacuna :FullUser :UserID @izpisUporabnika="IzpisiSe()" v-if="showBrisanjeR"/>
          </div>
          <!-- GUMB ZA PRIKAZ NAROČNIŠKEGA RAZMERJA -->
          <!--                                 <div class="modern-section">
                                              <div class="modern-section-header modern-clickable" @click.prevent="OpenSubscription()">
                                                  <div class="modern-section-icon modern-crown-icon">
                                                      <i class="fas fa-crown"></i>
                                                  </div>
                                                  <div class="modern-section-content">
                                                      <h6 class="modern-section-title">Urejanje naročnine</h6>
                                                      <p class="modern-section-desc">Upravljajte svojo naročnino</p>
                                                  </div>
                                                  <div class="modern-section-toggle">
                                                      <i class="fas fa-external-link-alt"></i>
                                                  </div>
                                              </div>
                                          </div> -->
          <!-- POMOČ UPORANBIKOM -->
          <div class="modern-section">
            <div class="modern-section-header modern-clickable" @click.prevent="PomocUporabnikom()">
              <div class="modern-section-icon modern-crown-icon">
                <i class="fas fa-question"></i>
              </div>
              <div class="modern-section-content">
                <h6 class="modern-section-title">Pomoč</h6>
                <p class="modern-section-desc">Pomoč uporabnikom</p>
              </div>
              <div class="modern-section-toggle">
                <i class="fas fa-external-link-alt"></i>
              </div>
            </div>
          </div>

        </div>
        <div class="modern-modal-footer col-12">
          <button class="modern-btn modern-btn-secondary" @click.prevent="DetailsOff">
            <i class="fas fa-check"></i>
            <span aria-hidden="true">{{$t('buttons.zakljuci')}}</span>
          </button>
        </div>
      </div>
    </div>
    <Transition name="fade">
      <Notification class="top-0" v-if="ShowNoti" :message="this.text" :type="this.types" @da="OpenStripeURL()" @ne="ShowNoti = false" @closeNotification="ShowNoti = false" />
    </Transition>
  </div>
</template>